<template>
    <DCard
        padding
    >
        <Form
            :mikkonaattori-settings="mikkonaattoriSettings"
            :errors="errors"
            @form-submitted="submitForm"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/Mikkonaattori/Form'
import { route } from '~@/Composables/route'

defineProps({
    mikkonaattoriSettings: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const submitForm = function (form) {
    form.post(route('settings.mikkonaattori-settings.store'))
}
</script>

<style scoped lang="scss">

</style>
